import { render } from "./PasswordReset.vue?vue&type=template&id=8dd2ece8"
import script from "./PasswordReset.vue?vue&type=script&lang=js"
export * from "./PasswordReset.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/SeekingSimple-SSUPR-V3/SeekingSimple-SSUPR-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/modules/auth/components/PasswordReset.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8dd2ece8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8dd2ece8', __exports__)) {
    api.reload('8dd2ece8', __exports__)
  }
  
  module.hot.accept("./PasswordReset.vue?vue&type=template&id=8dd2ece8", () => {
    api.rerender('8dd2ece8', render)
  })

}


export default __exports__